import React from 'react';

import { useGetTopHeaderContentFromStrapiQuery } from '@/store/api/product';

import './style.css';

interface TopHeaderContainerProps {
  isBackOffice?: boolean;
}

const TopHeaderContainer = ({ isBackOffice }: TopHeaderContainerProps) => {
  const { data } = useGetTopHeaderContentFromStrapiQuery();

  if (isBackOffice || !data?.visible) return null;

  const { default: defaultValue } = data;

  const promoHtml = defaultValue?.value?.value;
  let processedHtml = promoHtml;
  if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined' && promoHtml) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(promoHtml, 'text/html');
    doc.querySelectorAll('a').forEach(a => {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
    processedHtml = doc.body.innerHTML;
  }

  return (
    <div
      className="top-header-strapi-container v2-font-sweet-sans-pro v2-text-[15px] md:v2-text-[15px] sm:v2-text-xs xs:v2-text-xs v2-leading-[14px] v2-px-[15px] v2-font-normal v2-mb-0"
      dangerouslySetInnerHTML={{ __html: processedHtml || '' }}
    />
  );
};

export default TopHeaderContainer;
